// TODO: relocate client specific language; see https://hopper-jira.atlassian.net/wiki/spaces/ENGWEB/pages/1959952414/Discussion+on+practical+ways+to+prevent+adding+Cap+One+specific+language+into+Pawtucket
import { StayTypesEnum, cardsToShowLastFourOnRewardsBanner } from "redmond";
import { isCaponeTenant } from "@capone/common";
import { config } from "../../../../api/config";
import { getEarnMultiplier } from "../../utilities";

export const PREMIER_COLLECTION_REWARDS_DISABLED_BANNER_TEXT =
  "Rewards redemptions are temporarily unavailable. Card purchases will still earn rewards normally.";

export const PREMIER_COLLECTION_EARN_BANNER_TEXT = ({
  firstName,
  earnRate,
  productId,
  lastFour,
  currency,
  experienceCredit,
  isWithLifestyle,
  isLifestyleOnly,
  stayType,
  isUserPrimary,
}: {
  firstName: string;
  earnRate: string | number;
  productId: string;
  lastFour: string;
  currency: string;
  isWithLifestyle: boolean;
  isLifestyleOnly: boolean;
  experienceCredit?: string;
  stayType?: StayTypesEnum;
  isUserPrimary: boolean;
}) => {
  const { multiplier, currency: currencyText } = getEarnMultiplier(currency);
  const stayTypeText =
    stayType === StayTypesEnum.VacationRentals ? "vacation rental" : "hotel";

  const lifestyleRewardsBannerIntro =
    isCaponeTenant(config.TENANT) || isUserPrimary
      ? `earn <strong>${earnRate}${multiplier} ${currencyText}</strong> and enjoy a`
      : `enjoy a`;

  const collectionText = isLifestyleOnly
    ? "Lifestyle Collection"
    : "Premier & Lifestyle Collections";

  if (cardsToShowLastFourOnRewardsBanner.includes(productId.toLowerCase())) {
    if (stayType === StayTypesEnum.VacationRentals || isWithLifestyle) {
      return `${firstName}, earn <strong>${earnRate}${multiplier} ${currencyText}<strong/> on every <strong>${stayTypeText}</strong> booking from the ${collectionText} with your ${productId} account ending in ${lastFour}.`;
    }
    return experienceCredit
      ? `${firstName}, ${lifestyleRewardsBannerIntro} <strong>${experienceCredit} experience credit</strong> on ${isLifestyleOnly ? "Lifestyle" : "Premier"
      } Collection bookings with your <strong>${productId}</strong> card ending in ${lastFour}.`
      : `${firstName}, earn <strong>${earnRate}${multiplier} ${currencyText}</strong> on hotels and rental cars when you book with your ${productId} account ending in ${lastFour}.`;

  }
  if (stayType === StayTypesEnum.VacationRentals || isWithLifestyle) {
    return `${firstName}, earn <strong>${earnRate}${multiplier} ${currencyText}</strong> on every <strong>${stayTypeText}</strong> booking from the ${collectionText} with your <strong> ${productId}</strong> card.`;
  }
  return experienceCredit
    ? `${firstName}, ${lifestyleRewardsBannerIntro} <strong>${experienceCredit} experience credit</strong> on  ${isLifestyleOnly ? "Lifestyle" : "Premier"
    } Collection bookings with your <strong> ${productId}</strong> card.`
    : `${firstName}, earn ${earnRate}${multiplier} ${currencyText} on hotels and rental cars when you book with your ${productId} account.`;


};
